import React from 'react';
import PropTypes from 'prop-types';

export default class PageHeader extends React.Component {

  static propTypes = {
    references: PropTypes.array.isRequired,
  };

  get reference() {
    const {references} = this.props;
    if (references.length === 0) {
      return null;
    }

    const reference = references[0];
    return reference;
  }

  get pubmedURL() {
    const {reference} = this;
    if (!reference) {
      return null;
    }
    if (reference && !reference.medlineId) {
      return null;
    }

    const url = `https://pubmed.ncbi.nlm.nih.gov/${reference.medlineId}`;

    return (
      <a
       target="_blank"
       rel="noreferrer"
       href={url}>
        {reference.medlineId}
      </a>
    );
  }

  render() {
    const {reference} = this;
    if (!reference) {
      return null;
    }

    const {pubmedURL} = this;
    let pmid_stat = null;
    if (pubmedURL) {
      pmid_stat = (
        <span>
          (PMID: {pubmedURL})
        </span>
      );
    }


    return (
      <header>
        <h3>
          {reference.author}{'. '}{pmid_stat}
        </h3>
      </header>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/page-header/index.js